var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"centered"},[_c('h1',[_vm._v("AI Systems Manager")]),_vm._l((_vm.items),function(item){return _c('div',[_c('audit-item',{attrs:{"item":item}})],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }